import React, { useState } from "react";
import { Alert, Avatar, Box, Grid, Slide, Typography } from "@mui/material";
import { User } from "../../types/user";
import Modal from "../Modal/Modal";
import DeleteButton from "../DeleteButton/DeleteButton";
import { useDeleteDriverAvailabilitySlot } from "../../hooks/useDriverAvailability";
import { OrganizationDriverAvailabilitySlot } from "../../types/availability";
import Snackbar from "@mui/material/Snackbar";

type Props = {
  user: User | null;
  open: boolean;
  onClose: () => void;
  slot: OrganizationDriverAvailabilitySlot | null;
  accessToken: string;
};

const DriverDetailModal: React.FC<Props> = ({
  user,
  open,
  onClose,
  slot,
  accessToken,
}) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const { mutateAsync: deleteSlot, isLoading: loading } =
    useDeleteDriverAvailabilitySlot();
  if (!user || !slot) return null;

  const handleDelete = async () => {
    if (!slot) return;
    console.log("🧩 Deleting slot with ID:", slot.id);

    try {
      await deleteSlot({
        accessToken: accessToken,
        organizationDriverAvailabilitySlotId: slot.id,
      });
      onClose();
    } catch (error) {
      setSnackbarMessage("Failed to delete availability slot.");
      setSnackbarOpen(true);
      console.error("Failed to delete slot", error);
    }
  };

  return (
    <Modal
      open={open}
      title="User Details"
      handleClose={onClose}
      onCancel={onClose}
      onSubmit={onClose}
      submitButtonLabel="Close"
      withCancelButton={false}
    >
      <Box>
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <Avatar
              alt={`${user.firstName} ${user.lastName}`}
              src={user.avatar}
              sx={{ width: 64, height: 64 }}
            />
          </Grid>
          <Grid item>
            <Typography>
              <strong>Name:</strong> {user.firstName} {user.lastName}
            </Typography>
            <Typography>
              <strong>Email:</strong> {user.email}
            </Typography>
            <Typography>
              <strong>Phone:</strong> {user.phoneNumber}
            </Typography>
            <Typography>
              <strong>Role:</strong> {user.role}
            </Typography>
            <Typography>
              <strong>Status:</strong> {user.isOnline ? "Online" : "Offline"}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <DeleteButton onClick={handleDelete}>
              Delete Availability
            </DeleteButton>
          </Grid>
        </Grid>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackbarOpen(false)}
          sx={{ zIndex: 1500 }}
          TransitionComponent={Slide}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </Modal>
  );
};

export default DriverDetailModal;
